import * as THREE from "three";
import type { PooledVfx } from "../vfxPool";

/** How the wild pet is drawn (world units, seconds, CSS px). */
export const WILD_LOOK = {
  /** On the road as a boss: this much larger than the battle pet (it is the stage's big moment). */
  bossScale: 1.4,
  /** The findable pulse: its ring flares this often while it romps. */
  pulseEvery: 1.3,
  /** A coat's glint: sparkles this often round it. */
  glintEvery: 0.5,
  /** The dash to the portal once tapped, before it vanishes in a puff (it comes down the road from there). */
  dashSeconds: 0.5,
  /** The caught pet sits there this long, then goes in a sparkle. */
  caughtSeconds: 4.2,
  /** The tap: within this many CSS px of its feet or its middle. */
  reachPx: 58,
  /** The boss's clip rate range (its charge kept planted at the runner's speed). */
  bossRate: [0.6, 1.8] as const,
  hearts: [1, 0.55, 0.72] as [number, number, number],
  glint: [1, 0.93, 0.62] as [number, number, number],
} as const;

const _p = new THREE.Vector3();

/** The catch: hearts and glints burst where it sat up, a glow and a ring on the ground (`scale`: the pet's). */
export function caughtBurst(fx: PooledVfx | null, x: number, ground: number, z: number, scale: number): void {
  if (!fx) return;
  _p.set(x, ground + 0.2 * scale, z);
  fx.sparkles(_p, 22, { color: WILD_LOOK.hearts, radius: 0.35 * scale, rise: 1.4, life: 1.1, size: 0.16 });
  fx.sparkles(_p, 14, { color: WILD_LOOK.glint, radius: 0.3 * scale, rise: 1.0, life: 0.9, size: 0.12 });
  fx.glowPulse(_p, { size: 0.9 * scale, life: 0.5, color: WILD_LOOK.hearts });
  fx.ring(_p.set(x, ground + 0.05, z), { size: 1.6 * scale, life: 0.5, color: WILD_LOOK.glint });
}

/** The caught pet goes in a sparkle of glints. */
export function goneSparkle(fx: PooledVfx | null, at: THREE.Vector3, scale: number): void {
  fx?.sparkles(_p.set(at.x, at.y + 0.15 * scale, at.z), 16, { color: WILD_LOOK.glint, radius: 0.3, rise: 1.2, life: 0.8, size: 0.12 });
}
